import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Select as ShadcnSelect,
  SelectContent as ShadcnSelectContent,
  SelectGroup as ShadcnSelectGroup,
  SelectItem as ShadcnSelectItem,
  SelectLabel as ShadcnSelectLabel,
  SelectScrollDownButton as ShadcnSelectScrollDownButton,
  SelectScrollUpButton as ShadcnSelectScrollUpButton,
  SelectSeparator as ShadcnSelectSeparator,
  SelectTrigger as ShadcnSelectTrigger,
  SelectValue as ShadcnSelectValue,
} from "src/shadcn/components/select";

const Select = (props: React.ComponentProps<typeof ShadcnSelect>) => (
  <ShadcnSelect {...props} />
);

const SelectContent = (
  props: React.ComponentProps<typeof ShadcnSelectContent>
) => <ShadcnSelectContent {...props} />;

const SelectGroup = (props: React.ComponentProps<typeof ShadcnSelectGroup>) => (
  <ShadcnSelectGroup {...props} />
);

const SelectItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSelectItem>) => (
  <ShadcnSelectItem className={cn("cursor-pointer", className)} {...props} />
);

const SelectLabel = (props: React.ComponentProps<typeof ShadcnSelectLabel>) => (
  <ShadcnSelectLabel {...props} />
);

const SelectScrollDownButton = (
  props: React.ComponentProps<typeof ShadcnSelectScrollDownButton>
) => <ShadcnSelectScrollDownButton {...props} />;

const SelectScrollUpButton = (
  props: React.ComponentProps<typeof ShadcnSelectScrollUpButton>
) => <ShadcnSelectScrollUpButton {...props} />;

const SelectSeparator = (
  props: React.ComponentProps<typeof ShadcnSelectSeparator>
) => <ShadcnSelectSeparator {...props} />;

const SelectTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSelectTrigger>) => (
  <ShadcnSelectTrigger className={cn("cursor-pointer", className)} {...props} />
);

const SelectValue = (props: React.ComponentProps<typeof ShadcnSelectValue>) => (
  <ShadcnSelectValue {...props} />
);

export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
};
